export default "__VITE_ASSET__DqBVwJ0x__"